import { useState } from 'react';
import ApplicationDetail from '../components/ApplicationDetail';
import useFetchAgentAllianceApplicationDetail from '../api/useFetchAgentAllianceApplicationDetail';
import useUpdateAgentAllianceApplicationStatus from '../api/useUpdateAgentAllianceApplicationStatus';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';
import { getErrorMessage } from '../utils/getErrorMessage';

interface Props {
  applicationId: string;
}

export default function AllianceApplicationDetailTemplate({ applicationId }: Props) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { data: application, isLoading } = useFetchAgentAllianceApplicationDetail(applicationId);
  const updateStatus = useUpdateAgentAllianceApplicationStatus();

  const handleStatusChange = (newStatus: string) => {
    setErrorMessage(null);
    updateStatus.mutate(
      { id: applicationId, status: newStatus },
      {
        onSuccess: () => {
          showSuccessToast('ステータスを更新しました');
        },
        onError: (error) => {
          setErrorMessage(getErrorMessage(error, 'ステータスの更新に失敗しました'));
        },
      }
    );
  };

  return (
    <div className="bg-background flex flex-col gap-sm overflow-x-hidden px-lg pt-3 pb-lg">
      {errorMessage && (
        <div className="rounded border border-solid border-danger bg-red-50 p-sm">
          <p className="text-body-sm text-danger">{errorMessage}</p>
        </div>
      )}
      <ApplicationDetail
        applicationId={applicationId}
        application={application}
        isLoading={isLoading}
        onStatusChange={handleStatusChange}
      />
    </div>
  );
}
